import * as React from 'react';

export function ProblemSection() {
  return (
    <section className="edu-problem">
      <style>{`
        .edu-problem {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .edu-problem-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .edu-problem h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          line-height: 1.3;
        }
        .edu-problem .accent {
          font-size: 22px;
          font-weight: 600;
          color: #c53030;
          margin: 0 0 28px;
        }
        .edu-problem p {
          font-size: 16px;
          color: #444;
          line-height: 1.7;
          margin: 0 0 20px;
        }
        .edu-problem .highlight {
          font-weight: 600;
          color: #1a1a1a;
        }
        .edu-fail-list {
          list-style: none;
          padding: 0;
          margin: 24px 0 0;
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
        }
        .edu-fail-list li {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 15px;
          color: #555;
          padding: 10px 14px;
          background: #fef2f2;
          border-radius: 8px;
        }
        .edu-fail-list li i {
          color: #c53030;
          font-size: 14px;
          flex-shrink: 0;
        }
        @media (max-width: 640px) {
          .edu-problem h2 {
            font-size: 24px;
          }
          .edu-fail-list {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
      <div className="edu-problem-inner">
        <h2>Gestionar un comedor escolar no es fácil.</h2>
        <p className="accent">Un proveedor que falla lo complica todavía más.</p>
        <p>
          Coordinar menús, controlar presupuestos y garantizar calidad nutricional es un desafío diario.
          Lo último que necesitás es un proveedor que <span className="highlight">llegue tarde, cambie precios sin aviso o entregue productos en mal estado</span>.
        </p>
        <p className="highlight">Un proveedor poco confiable genera:</p>
        <ul className="edu-fail-list">
          <li><i className="fa fa-times-circle" /> Cambios de menú de último momento</li>
          <li><i className="fa fa-times-circle" /> Desperdicio de alimentos</li>
          <li><i className="fa fa-times-circle" /> Quejas de padres y familias</li>
          <li><i className="fa fa-times-circle" /> Costos impredecibles</li>
        </ul>
      </div>
    </section>
  );
}
